import CustomFilterText from "../unit/CustomFilterText";
import FilterDateLastYear from "../unit/FilterDateLastYear";
import FilterProduct from "../unit/FilterProduct";

const CampaignsApplicationsFilters = [
  <CustomFilterText label="Page Name" source="campaign_name" defaultValue="" />,
  <CustomFilterText label="Page Token" source="share_token" defaultValue="" />,
  <FilterDateLastYear
    label="Sign Up"
    source="signup"
    before="and"
    variant="outlined"
  />,
  <FilterDateLastYear
    label="Application Submitted"
    source="application_submitted"
    before="and"
    variant="outlined"
  />,
  <FilterProduct label="Product" source="product" before="and" />,
];

export default CampaignsApplicationsFilters;
